import type { AppointmentStatus } from '../../types.ts'

export const APPOINTMENT_STATUSES: AppointmentStatus[] = [
  'new',
  'dispatched',
  'cancelled',
  'completed',
  'all',
]
